import { ApiBase } from "./api-base";

export class HttpMonitoringApi extends ApiBase {
  // API 설정/관리 command를 기존 백엔드와 분리된 /monitoring 라우트로 보내기 위한 API 이름을 제공한다.
  onApiName(): string {
    return "MonitoringApi";
  }

  // API Gateway에 새로 추가한 모니터링 전용 경로를 반환한다.
  onUrlPath(): string {
    return "/monitoring";
  }

  // 기존 API wrapper 패턴과 동일하게 API Key 포함 POST 요청을 수행한다.
  public async post(param: any) {
    const response = await this.requestPostAxiosWithKey(param);
    return response;
  }
}
